"use strict";
/**
 *
 * useDebouncedState
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useDebouncedState(delay, initialState) {
    const [state, setState] = react_1.useState(() => initialState);
    const [debouncedState, setDebouncedState] = react_1.useState(() => state);
    react_1.useEffect(() => {
        const timeout = setTimeout(() => setDebouncedState(state), delay);
        return () => clearTimeout(timeout);
    }, [state]);
    return [debouncedState, setState];
}
exports.useDebouncedState = useDebouncedState;
